// src/pages/PortalLoginPage.js
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { usePortalAuth } from '../context/PortalAuthContext';
import toast from 'react-hot-toast';

export default function PortalLoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = usePortalAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) return;
    setLoading(true);
    try {
      await login(email, password);
      toast.success('Welcome back!');
      // [marker: finish-up v1] back to where they were going (only portal pages)
      const next = new URLSearchParams(window.location.search).get('next') || '';
      navigate(/^\/portal(\/|$)/.test(next) ? next : '/portal');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Login failed.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', background: 'var(--navy, #1a3a5c)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20,
    }}>
      <div style={{ width: '100%', maxWidth: 400 }}>
        <div style={{ textAlign: 'center', marginBottom: 40 }}>
          <h1 style={{ fontFamily: 'var(--font-serif)', fontSize: '2rem', color: 'white', marginBottom: 6 }}>NJJBA</h1>
          <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.875rem', letterSpacing: '1px', textTransform: 'uppercase' }}>
            Member Portal
          </p>
        </div>
        <div className="card" style={{ padding: '32px 36px' }}>
          <h2 style={{ marginBottom: 24, color: 'var(--navy)', fontFamily: 'var(--font-serif)' }}>Sign In</h2>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">Email Address</label>
              <input
                type="email"
                className="form-input"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="you@yourbusiness.com"
                autoFocus
                required
              />
            </div>
            <div className="form-group">
              <label className="form-label">Password</label>
              <input
                type="password"
                className="form-input"
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="••••••••"
                required
              />
            </div>
            <button type="submit" className="btn btn-primary w-full btn-lg" disabled={loading} style={{ marginTop: 8, justifyContent: 'center' }}>
              {loading ? <><span className="spinner" style={{ width: 16, height: 16 }} /> Signing in...</> : 'Sign In'}
            </button>
          </form>
          <div style={{ textAlign: 'center', marginTop: 16, fontSize: '0.85rem' }}>
            <Link to="/portal/forgot-password" style={{ color: 'var(--navy)' }}>Forgot your password?</Link>
          </div>
          <div style={{ textAlign: 'center', marginTop: 8, fontSize: '0.75rem', color: 'var(--gray-500)' }}>
            Don't have an account yet? Contact NJJBA staff.
          </div>
        </div>
        <p style={{ textAlign: 'center', color: 'rgba(255,255,255,0.3)', fontSize: '0.75rem', marginTop: 24 }}>
          New Jersey Jewish Business Alliance · portal.njjba.com
        </p>
      </div>
    </div>
  );
}
